import React, { useContext } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
//import AuthContext from './context/AuthProvider';
import MainLayout from './components/MainLayout';
import useAuth from "./hooks/useAuth.js";

const ProtectedRoute = ({ children }) => {
    //const { auth } = useContext(AuthContext);
    const { auth } = useAuth();

    console.log("Root.js > ProtectedRoute > auth: ", auth)
    return auth.isAuthenticated ? children : <Navigate to="/login" replace />;
};

const Root = () => {
    return (
        <ProtectedRoute>
            <MainLayout>
                <Outlet />
            </MainLayout>
        </ProtectedRoute>
    );
};

export default Root;
